module.exports = __webpack_public_path__ + "img/logo.0e1d60a2.jpg";